"use strict";

const SEAL_PERCENT_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256" fill="none"><path d="M225.86,102.82c-3.77-3.94-7.67-8-9.14-11.57-1.36-3.27-1.44-8.69-1.52-13.94-.15-9.76-.31-20.82-8-28.51s-18.75-7.85-28.51-8c-5.25-.08-10.67-.16-13.94-1.52-3.56-1.47-7.63-5.37-11.57-9.14C146.35,23.51,138.93,16.68,128,16.68S109.65,23.51,103,30.18c-3.94,3.77-8,7.67-11.57,9.14C88.18,40.68,82.76,40.76,77.51,40.84c-9.76.15-20.82.31-28.51,8s-7.85,18.75-8,28.51c-.08,5.25-.16,10.67-1.52,13.94-1.47,3.56-5.37,7.63-9.14,11.57C23.51,109.65,16.68,117.07,16.68,128s6.83,18.35,13.5,25c3.77,3.94,7.67,8,9.14,11.57,1.36,3.27,1.44,8.69,1.52,13.94.15,9.76.31,20.82,8,28.51s18.75,7.85,28.51,8c5.25.08,10.67.16,13.94,1.52,3.56,1.47,7.63,5.37,11.57,9.14,6.65,6.67,14.07,13.5,25,13.5s18.35-6.83,25-13.5c3.94-3.77,8-7.67,11.57-9.14,3.27-1.36,8.69-1.44,13.94-1.52,9.76-.15,20.82-.31,28.51-8s7.85-18.75,8-28.51c.08-5.25.16-10.67,1.52-13.94,1.47-3.56,5.37-7.63,9.14-11.57,6.67-6.65,13.5-14.07,13.5-25S232.49,109.65,225.86,102.82Z" fill="#0056FF" opacity="0.2"/><line x1="168" y1="88" x2="88" y2="168" stroke="#0056FF" stroke-width="16" stroke-linecap="round" stroke-linejoin="round"/><circle cx="100" cy="100" r="12" stroke="#0056FF" stroke-width="16" stroke-linecap="round" stroke-linejoin="round"/><circle cx="156" cy="156" r="12" stroke="#0056FF" stroke-width="16" stroke-linecap="round" stroke-linejoin="round"/><path d="M225.86,102.82c-3.77-3.94-7.67-8-9.14-11.57-1.36-3.27-1.44-8.69-1.52-13.94-.15-9.76-.31-20.82-8-28.51s-18.75-7.85-28.51-8c-5.25-.08-10.67-.16-13.94-1.52-3.56-1.47-7.63-5.37-11.57-9.14C146.35,23.51,138.93,16.68,128,16.68S109.65,23.51,103,30.18c-3.94,3.77-8,7.67-11.57,9.14C88.18,40.68,82.76,40.76,77.51,40.84c-9.76.15-20.82.31-28.51,8s-7.85,18.75-8,28.51c-.08,5.25-.16,10.67-1.52,13.94-1.47,3.56-5.37,7.63-9.14,11.57C23.51,109.65,16.68,117.07,16.68,128s6.83,18.35,13.5,25c3.77,3.94,7.67,8,9.14,11.57,1.36,3.27,1.44,8.69,1.52,13.94.15,9.76.31,20.82,8,28.51s18.75,7.85,28.51,8c5.25.08,10.67.16,13.94,1.52,3.56,1.47,7.63,5.37,11.57,9.14,6.65,6.67,14.07,13.5,25,13.5s18.35-6.83,25-13.5c3.94-3.77,8-7.67,11.57-9.14,3.27-1.36,8.69-1.44,13.94-1.52,9.76-.15,20.82-.31,28.51-8s7.85-18.75,8-28.51c.08-5.25.16-10.67,1.52-13.94,1.47-3.56,5.37-7.63,9.14-11.57,6.67-6.65,13.5-14.07,13.5-25S232.49,109.65,225.86,102.82Z" stroke="#0056FF" stroke-width="16" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

const ARROW_POST_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M7 17L17 7" stroke="#0056FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17 16V7H8" stroke="#0056FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

export default function casesFilter() {
    const section = document.getElementById("js-cases-section");
    if (!section) return;

    const filter = document.getElementById("js-cases-filter");
    const featuredWrap = document.getElementById("js-cases-featured");
    const casesGrid = document.getElementById("js-cases-grid");
    const skeleton = document.getElementById("js-cases-skeleton");
    const pagination = document.getElementById("js-blog-pagination");
    const pagesList = document.getElementById("js-pagination-pages");
    const prevBtn = document.getElementById("js-pagination-prev");
    const nextBtn = document.getElementById("js-pagination-next");

    const nonce = section.dataset.nonce || "";
    let currentCategory = 0;
    let currentPage = 1;
    let totalPages = parseInt(section.dataset.totalPages, 10) || 1;

    renderPagination(totalPages, currentPage);

    function showSkeleton() {
        featuredWrap.style.display = "none";
        casesGrid.style.display = "none";
        skeleton.style.display = "grid";
    }

    function hideSkeleton() {
        skeleton.style.display = "none";
        featuredWrap.style.display = "block";
        casesGrid.style.display = "grid";
    }

    function escapeHtml(str) {
        const div = document.createElement("div");
        div.appendChild(document.createTextNode(str || ""));
        return div.innerHTML;
    }

    function truncate(str, len) {
        if (!str) return "";
        return str.length > len ? str.slice(0, len - 3) + "..." : str;
    }

    function renderFeatured(c) {
        const logoHtml = c.icone_url
            ? `<div class="c-case-featured__logo"><img src="${escapeHtml(c.icone_url)}" alt="${escapeHtml(c.title)}" loading="lazy"></div>`
            : "";
        const thumbnail = c.thumbnail
            ? `<img src="${escapeHtml(c.thumbnail)}" alt="${escapeHtml(c.title)}" loading="lazy">`
            : "";
        const tagsHtml =
            c.case_tags && c.case_tags.length
                ? `<ul class="c-case-featured__tags">${c.case_tags
                      .map(
                          (t) =>
                              `<li class="c-case-featured__tag"><span class="c-case-featured__tag-icon">${SEAL_PERCENT_SVG}</span><span class="c-case-featured__tag-name">${escapeHtml(t)}</span></li>`,
                      )
                      .join("")}</ul>`
                : "";

        return `<a href="${escapeHtml(c.permalink)}" class="c-case-featured">
      <div class="c-case-featured__image">
        <div class="c-case-featured__image-wrap">${thumbnail}</div>
        ${logoHtml}
      </div>
      <div class="c-case-featured__body">
        <h2 class="c-case-featured__title">${escapeHtml(truncate(c.title, 84))}</h2>
        <p class="c-case-featured__excerpt">${escapeHtml(truncate(c.excerpt, 160))}</p>
        ${tagsHtml}
      </div>
    </a>`;
    }

    function renderCard(c) {
        const logoHtml = c.icone_url
            ? `<div class="c-case__logo"><img src="${escapeHtml(c.icone_url)}" alt="${escapeHtml(c.title)}" loading="lazy"></div>`
            : "";
        const thumbnail = c.thumbnail
            ? `<img src="${escapeHtml(c.thumbnail)}" alt="${escapeHtml(c.title)}" loading="lazy">`
            : "";

        return `<article class="c-case">
      <div class="c-case__image">
        <a href="${escapeHtml(c.permalink)}" class="c-case__image-wrap">${thumbnail}</a>
        ${logoHtml}
      </div>
      <div class="c-case__content">
        <div class="c-case__text">
          <a href="${escapeHtml(c.permalink)}"><h3 class="c-case__title">${escapeHtml(truncate(c.title, 65))}</h3></a>
          <div class="c-case__excerpt">${escapeHtml(truncate(c.excerpt, 84))}</div>
        </div>
        <a href="${escapeHtml(c.permalink)}" class="c-case__arrow" aria-label="Ver case">${ARROW_POST_SVG}</a>
      </div>
    </article>`;
    }

    function renderCases(cases) {
        if (!cases.length) {
            featuredWrap.innerHTML = `<p class="p-cases__empty">Nenhum case encontrado.</p>`;
            casesGrid.innerHTML = "";
            return;
        }

        featuredWrap.innerHTML = renderFeatured(cases[0]);

        casesGrid.innerHTML = "";
        cases.slice(1).forEach((c) => {
            casesGrid.insertAdjacentHTML("beforeend", renderCard(c));
        });
    }

    function renderPagination(total, current) {
        pagesList.innerHTML = "";

        if (total <= 1) {
            pagination.style.display = "none";
            return;
        }

        pagination.style.display = "flex";
        prevBtn.disabled = current <= 1;
        nextBtn.disabled = current >= total;

        const range = getPageRange(current, total);
        range.forEach((p) => {
            const li = document.createElement("li");
            li.classList.add("c-pagination__page");
            if (p === current) li.classList.add("c-pagination__page--active");

            if (p === "...") {
                li.innerHTML = `<span class="c-pagination__ellipsis">...</span>`;
            } else {
                const btn = document.createElement("button");
                btn.type = "button";
                btn.textContent = String(p).padStart(2, "0");
                btn.addEventListener("click", () =>
                    fetchCases(currentCategory, p),
                );
                li.appendChild(btn);
            }

            pagesList.appendChild(li);
        });
    }

    function getPageRange(current, total) {
        if (total <= 7) {
            return Array.from({ length: total }, (_, i) => i + 1);
        }
        const pages = [];
        pages.push(1);
        if (current > 3) pages.push("...");
        for (
            let i = Math.max(2, current - 1);
            i <= Math.min(total - 1, current + 1);
            i++
        ) {
            pages.push(i);
        }
        if (current < total - 2) pages.push("...");
        pages.push(total);
        return pages;
    }

    function fetchCases(categoryId, paged) {
        showSkeleton();
        currentPage = paged;

        window
            .fetch(phpVars.ajaxUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: new URLSearchParams({
                    action: "filter_cases",
                    nonce,
                    category_id: categoryId,
                    paged,
                }),
            })
            .then((res) => res.json())
            .then((json) => {
                if (!json.success) return;
                totalPages = json.data.total_pages;
                renderCases(json.data.cases);
                renderPagination(totalPages, currentPage);
                section.scrollIntoView({ behavior: "smooth", block: "start" });
            })
            .catch(console.error)
            .finally(hideSkeleton);
    }

    if (filter) {
        filter.addEventListener("click", (e) => {
            const tab = e.target.closest(".c-blog-filter__tab");
            if (!tab) return;

            filter
                .querySelectorAll(".c-blog-filter__tab")
                .forEach((t) =>
                    t.classList.remove("c-blog-filter__tab--active"),
                );
            tab.classList.add("c-blog-filter__tab--active");

            currentCategory = parseInt(tab.dataset.category, 10) || 0;
            fetchCases(currentCategory, 1);
        });
    }

    prevBtn.addEventListener("click", () => {
        if (currentPage > 1) fetchCases(currentCategory, currentPage - 1);
    });

    nextBtn.addEventListener("click", () => {
        if (currentPage < totalPages)
            fetchCases(currentCategory, currentPage + 1);
    });
}
